import React, {useState, useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import APIURL from '../components/Constant'
import Cookies from 'js-cookie';
import axios from "axios";
import Popup from "../components/PopUP";


export default function VerifyOTP() {
      const navigate = useNavigate();
      const [loading, setLoading] = useState(false);
      const [otp, setOtp] = useState(["", "", "", ""]);
      const [error, setError] = useState("");
      const [email, setEmail] = useState("");
      const [popupMessage, setPopupMessage] = useState("");

    useEffect(() => {
        const email = Cookies.get('forget_email') || navigate('/forget');
        setEmail(email);
    }, [navigate]);

    const handleSubmit = async () => {
    setLoading(true)
    const otpCode = otp.join("");

    if (!otpCode) {
        setError("OTP is required for verification");
        setLoading(false)
        return; 
    }

    const data = {
        email: email,
        otp: otpCode,
        otp_type: "forget_password"
    }


    try {
        const response = await axios.post(APIURL+"/user-service/auth/verify-forget-password", data);
        console.log("Response:", response.data);
        Cookies.remove('forget_email');
        Cookies.set('verify_email', email, { expires: 1/24 }); // Expires in 1 hour
        setPopupMessage(response.data.detail)
        setLoading(false)
        setTimeout(() => {
            navigate('/createnewpassword');
        }, 3000);
    } catch (error) {
        setError(error.response && error.response.data ? error.response.data.detail || "Something wrong please try again." : "Something wrong please try again.");
        console.log("Error:", error);
        setLoading(false)
    }

  }


    // Handle input change
    const handleChange = (e, index) => {
        const value = e.target.value;

        // Only allow single character numbers
        if (/^[0-9]?$/.test(value)) {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move focus to next input if a digit is entered
        if (value && index < otp.length - 1) {
            const nextInput = document.getElementById(`otp${index + 2}`);
            if (nextInput) nextInput.focus();
        }
        }
    };



    return (
        <>
        <>
        <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
        <div className="credential_main_wrapper">
            <div className="credential_content_outer">
            <div className="credential_content_wrapper">
                <div className="credential_logo">
                <img src="assets/images/logo-white.svg" alt="Logo" />
                </div>
            </div>
            </div>

            <div className="credential_form_wrapper">
            <div className="credential_form_card">
                <div className="credential_content_info">
                <h1>OTP Verification</h1>
                <p className="mb-0 credential_sub_heading">
                    Enter the code sent to your email
                </p>
                </div>

                <div className="form_field_wrapper">
                    <div className="form_flex_field">
                    <div className="input_field otp_field">
                        {otp.map((digit, index) => (
                            <input
                            key={index}
                            type="text"
                            className="form-control otp_input"
                            maxLength="1"
                            id={`otp${index + 1}`}
                            value={digit}
                            onChange={(e) => handleChange(e, index)}
                            autocomplete="off"
                            />
                        ))}
                    </div>
                     {error && <span className="error" style={{marginLeft:'150px'}}>{error}</span>}
                    </div>
                </div>

                <div className="form-btn-blk">
                    {loading ? 
                    <button
                    type="button"
                    className="form-btn w-100 fw-bold text-white text-capitalize disabled"
                    disabled
                    >
                    Verify
                    </button>
                    :
                    <button
                    type="button"
                    className="form-btn w-100 fw-bold text-white text-capitalize"
                    onClick={handleSubmit}
                    >
                    Verify
                    </button>
                }
                </div>

                <div className="have_an-account_blk">
                {/* <p className="text-center mb-0">
                    Didn’t receive the OTP?
                    <button
                    type="button"
                    className="border-0 bg-white p-0 text-clr fw-semibold text-decoration-none ms-2"
                    >
                    Resend
                    </button>
                </p> */}
                </div>
            </div>
            </div>
        </div>
        </>

        </>

    )
}
